$(function() {
    if (window.self !== window.top || !window.tinymce) {
        return;
    }

    tinymce.PluginManager.add('embedvideo_yoda', function(ed, url) {
        var html = '<div class="mce-container mce-panel mce-floatpanel mce-window mce-in">\
                        <div class="mce-window-head"></div>\
                        <div class="mce-container-body mce-abs-layout">\
                            <iframe id="popup-iframe" src="http://staging.community.eu.playstation.com/t5/video/embedpopuppage/board-id/bEN_PAIN_GD"></iframe>\
                        </div>\
                    </div>\
                    <div class="emoticons-picker-backdrop"></div>';

        ed.addButton('embedvideo_yoda', {
            title : 'video.desc',
            type  : 'panelbutton',
            image : '',
            panel : {
                classes: 'lia-emoticons-panel',
                html: html,
                onshow: function() {
                    common.els.$body.header('toggleBodyOverflow', true);
                },
                onhide: function() {
                    common.els.$body.header('toggleBodyOverflow', false);
                }/*,
                onclick: function(e) {
                    var $target = $(e.target),
                        $parent = $target.parent();

                    if ($target.hasClass('emoticons-close') || $parent.hasClass('emoticons-close')) {
                        this.hide();
                        return;
                    }

                    if ($target.attr('class').indexOf('cat-') >= 0 && !$target.hasClass('active')) {
                        var $emo = $('.EmoticonView');
                        var $li = $emo.find('li[data-cat="cat-' + ( $target.index() + 1 ) + '"]');

                        $emo.scrollTop(0);
                        $li.show().siblings().hide();
                        $target.addClass('active').siblings().removeClass('active');

                        return;
                    }

                    if ($target.hasClass('emoticon-link') || $parent.hasClass('emoticon-link')) {
                        var content = $target.attr('alt');
                        if (!content) {
                            content = $target.children().attr('alt');
                        }

                        ed.insertContent(content);
                        this.hide();
                        return;
                    }

                    return;
                }
                */
            }
        });
    });
});

/*
// Singleton class
var LITHIUM_VideoPlugin = {
    // Attribute regex from John Resig's HTML parser
    // http://ejohn.org/files/htmlparser.js
    parseAttributes: function(attributeString) {
        var attrRegExp = /(\w+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|([^>\s]+)))?/g,
            attrs = {};

        attributeString.replace(attrRegExp, function(match, name) {
            var value = arguments[2] ? arguments[2] :
                arguments[3] ? arguments[3] :
                arguments[4] ? arguments[4] : "";


            attrs[name] = value;
        });

        return attrs;
    },

    makeWYSIWYG: function(attributeString, tooltip) {
        var imgUrl = '';
        attrs = this.parseAttributes(attributeString);

        attrs['mcewidth'] = attrs['width'];
        attrs['mceheight'] = attrs['height'];

        var alignString;
        if (attrs['align'] != null && attrs['align'].toLowerCase() == 'left') {
            alignString = "align='left'";
        } else if (attrs['align'] != null && attrs['align'].toLowerCase() == 'right') {
            alignString = "align='right'";
        }

        var imageAtts = new Array();
        imageAtts.push(alignString);
        imageAtts.push("style=\"border: dotted 1px black; background-position:center; background-repeat: no-repeat; background-image:url('" + attrs.thumbnail + "');\"");
        imageAtts.push("livideoattrs='" + LITHIUM.jQuery.toJSON(attrs) + "'");
        imageAtts.push("width='" + attrs.width + "'");
        imageAtts.push("height='" + attrs.height + "'");
        imageAtts.push("src='/i/p.gif'");
        imageAtts.push("border='0'");
        imageAtts.push("class='mceItemLithiumVideo'");
        if (tooltip != null) {
            imageAtts.push("title='"+tooltip+"'");
        }

        var imageAttsString = imageAtts.join(" ");
        var divWrapper = document.createElement("div")
        divWrapper.innerHTML = "<img " + imageAttsString + "></img>";

        return divWrapper.innerHTML;
    },

    xmlDecode: function(toUnescape) {
        return toUnescape
            .replace(/&lt;/g,'<')
            .replace(/&gt;/g,'>')
            .replace(/&quot;/g, '"')
            .replace(/&amp;/g,'&');
    },

    editExistingVideo: function(ed) {
//      var options = { editor_id: editor_id, scrollbars: 'yes', resizable: 'yes'};

        // This code is based on code from imageplus
        var img = ed.selection.getNode();

        // If not Lithium video, nothing to do
        if (ed.dom.getAttrib(img, 'class') != 'mceItemLithiumVideo') {
            return true;
        }

        // Parse attributes
        var at = ed.dom.getAttrib(img, 'livideoattrs');
        if (!at) {
            return true;
        }

        at = this.xmlDecode(at);
        var videoAttributes = LITHIUM.jQuery.evalJSON(at);
        videoAttributes.width = img.width;
        videoAttributes.height = img.height;

        if (videoAttributes.mceheight != videoAttributes.height
                || videoAttributes.mcewidth != videoAttributes.width) {
            videoAttributes.size = 'custom';
        }

        var file;

        if (videoAttributes.external == null || videoAttributes.external == "") {
            file = LITHIUM.VideoEmbedPopupPageGalleryTab;
        } else {
            file = LITHIUM.VideoEmbedPopupPageExternalTab;
        }

        file += "/video-id/" + videoAttributes.vid + "/video-align/" + videoAttributes.align.toLowerCase() + "/video-size/" + videoAttributes.size.toLowerCase();

        ed.windowManager.open({
            file : file,
            width : 700 + parseInt(ed.getLang('video.delta_width', 0)),
            height : 800 + parseInt(ed.getLang('video.delta_height', 0)),
            inline : false,
            action: 'update'
        });


    },
    convertLiVideoTag: function(content, tooltip) {
        // Read <li-video>...</li-video> and convert to visual

        var match, replacement,
            regExpVideoClosingTags = /<\/li-video>/mgi,
            regExpVideoTags = /<li-video([^>]*?)\/?>/mgi;

        if (typeof content == "string") {
            content = content.replace(regExpVideoClosingTags, '');
        }

        while ((match = regExpVideoTags.exec(content)) != null) {
            replacement = LITHIUM_VideoPlugin.makeWYSIWYG(match[1], tooltip);
            content = content.substring(0, match.index) + replacement + content.substring(match.index + match[0].length);
            regExpVideoTags.lastIndex = 0; // Start search back at beginning
        }
        return content;
    },
    convertToLiVideoTag: function(content) {
        var match, attrs, at, videoAttributes, replacement,
                regExpImageTags = /<img([^>]*?)\/?>/mgi;

        while ((match = regExpImageTags.exec(content)) != null) {
            attrs = replacement = LITHIUM_VideoPlugin.parseAttributes(match[1]);

            // If not Lithium video, skip it
            if (attrs['livideoattrs'] == null) {
                continue;
            }

            // Parse attributes
            at = attrs['livideoattrs'];
            if (at) {
                at = LITHIUM_VideoPlugin.xmlDecode(at);

                videoAttributes = LITHIUM.jQuery.evalJSON(at);
                videoAttributes.width = attrs['width'];
                videoAttributes.height = attrs['height'];

                if (videoAttributes.mceheight != videoAttributes.height
                        || videoAttributes.mcewidth != videoAttributes.width) {
                    videoAttributes.size = "CUSTOM";
                }

                var elem = document.createElement('li-video');

                for (var prop in videoAttributes) {
                    if (prop.toLowerCase() != 'mceheight' && prop.toLowerCase() != 'mcewidth') {
                        elem.setAttribute(prop, videoAttributes[prop]);
                    }
                }

                var div = document.createElement('div');
                div.appendChild(elem);
                replacement = div.innerHTML;
            } else {
                replacement = '';
            }

            content = content.substring(0, match.index) + replacement + content.substring(match.index + match[0].length);

            regExpImageTags.lastIndex = 0; // Start search back at beginning
        }
        return content;
    },
    hasVideoContent: function(content) {
        var regExpVideoTags = /<li-video([^>]*?)\/?>/mgi;
        return (match = regExpVideoTags.exec(content)) != null;
    }
};

$(function() {
    if (window.self !== window.top) {
        return;
    }

    // Load plugin specific language pack
    tinymce.PluginManager.requireLangPack('video');

    console.log(tinymce);

    tinymce.create('tinymce.plugins.VideoPluginYoda', {
        init : function(ed, url) {

            ed.addCommand('mceShowEmbedVideoYoda', function() {
                // If a video is selected, open the editor for that video.

                var node = ed.selection.getNode();
                if (node != null
                        && node.nodeName.toLowerCase() == 'img'
                        && node.className == 'mceItemLithiumVideo') {
                    return LITHIUM_VideoPlugin.editExistingVideo(ed);
                }

                ed.windowManager.open({
                    file : LITHIUM.VideoEmbedPopupPageDefaultTab,
                    width : 700 + parseInt(ed.getLang('video.delta_width', 0)),
                    height : 800 + parseInt(ed.getLang('video.delta_height', 0)),
                    inline : false
                });
                ed.nodeChanged()
            });

            ed.addCommand('mceInsertVideo', function(e, value) {

                var uploadFlag = value.uploading ? 'true' : 'false';

                var videoAttributes = {vid:value.videoId, align:value.align, size:value.sizeString,
                width:value.size.width, height:value.size.height, uploading:uploadFlag,
                originalWidth:value.originalWidth, originalHeight:value.originalHeight,
                thumbnail:value.thumbnailUrl};

                if (value.external !== "") {
                    videoAttributes.external = value.external;
                    if(value.external === "minavoxsavisys") {
                        videoAttributes.cid = value.cid;
                        videoAttributes.pid = value.pid;
                        videoAttributes.unm = value.unm;
                    }
                }

                //old school, prototype style not working for IE
                var elem = document.createElement('li-video');
                for (var prop in videoAttributes) {
                    elem.setAttribute(prop, videoAttributes[prop]);
                }
                var div = document.createElement('div');
                div.appendChild(elem);
                var html = div.innerHTML;

                html = LITHIUM_VideoPlugin.convertLiVideoTag(html, value.tooltip);
                tinyMCE.selectedInstance.execCommand('mceInsertContent', false, html);
            });

            // Register example button
            ed.addButton('embedvideo_yoda', {
                title : 'video.desc',
                cmd : 'mceShowEmbedVideoYoda',
                image : '',
                onPostRender: function() {
                    var ctrl = this;

                    // Add a node change handler, selects the button in the UI when a image is selected
                    ed.on('NodeChange', function(e) {
                        var node = e.element;
                        ctrl.active(node.nodeName == 'IMG' && node.className == "mceItemLithiumVideo");
                    });

                    ed.on('SaveContent', function(e) {
                        e.content = LITHIUM_VideoPlugin.convertToLiVideoTag(e.content);
                    });

                    ed.on('BeforeExecCommand', function(e) {
                        var cmd = e.command, val = e.value;

                        if (cmd = "mceInsertContent") {
                            if (typeof val == "string" && LITHIUM_VideoPlugin.hasVideoContent(val)) {
                                e.terminate = true;
                                var converted = LITHIUM_VideoPlugin.convertLiVideoTag(val);
                                ed.selection.setContent(converted)
                            }
                        }
                    });

                    ed.on('BeforeSetContent', function(e) {
                        // Read <li-video>...</li-video> and convert to visual
                        e.content = LITHIUM_VideoPlugin.convertLiVideoTag(e.content);
                    });
                }
            });
        },

        getInfo : function() {
            return {
                longname : 'Video',
                author : 'Andrew Fowler',
                authorurl : 'http://www.lithium.com',
                infourl : 'http://www.lithium.com',
                version : '1.0'
            };
        }
    });

    // Register plugin
    tinymce.PluginManager.add('video_yoda', tinymce.plugins.VideoPluginYoda);
});
*/
